import {
    EditButton,
    ShowActionsProps,
    TitlePortal,
    TopToolbar,
    useRecordContext,
    useResourceDefinition,
} from 'react-admin';
import { ReactNode } from 'react';
import BackButton from '../../common/BackButton';
import { Stack } from '@mui/material';

const ShowActions = (
    props: ShowActionsProps & { hasEdit?: boolean; extraActions?: ReactNode }
) => {
    const record = useRecordContext(props);
    const { hasEdit } = useResourceDefinition(props);

    return (
        <TopToolbar
            className={props.className}
            sx={{
                mb: 2,

                flexDirection: {
                    xs: 'column',
                    md: 'row',
                },
                alignItems: {
                    xs: 'stretch',
                    md: 'center',
                },
                justifyContent: 'space-between'
            }}
        >
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
                <BackButton type={'icon'} />

                <TitlePortal variant={'h1'} whiteSpace={'break-spaces'} />
            </Stack>

            <Stack direction={'row'} justifyContent={'flex-end'} spacing={1}>
                {props.extraActions}

                {hasEdit && <EditButton record={record} />}
            </Stack>
        </TopToolbar>
    );
};

export default ShowActions;
